import { productType } from '@selfserve/react-utils';

import { useProductUpdateFormik } from '../hooks/use-product-update-formik';

import { AdminUpdateBreadcrumb } from '../ui/admin-update-breadcrumb';
import { AdminProductFields } from '../ui/admin-product-fields';
import { AdminSpinner } from '../ui/admin-spinner';

// Mock schema / remove after BE integration
import { schema } from '../constants/package-schema-mock';

export const AdminPackageUpdate = () => {
  const { formik, disabled, disableToggle, isLoading } =
    useProductUpdateFormik(true);

  return (
    <form onSubmit={formik.handleSubmit}>
      <AdminUpdateBreadcrumb
        type={productType.PACKAGES}
        disableToggle={disableToggle}
        isLoading={isLoading}
        disabled={disabled}
        product={formik.values}
        disableSave={Object.entries(formik.errors).some( e => {return !!e[0] && !!e[1]})}
      />
      <AdminProductFields
        formik={formik}
        disabled={disabled}
        schema={schema}
      />
      <AdminSpinner loading={isLoading} fullScreen />
    </form>
  );
};
